import { createSelector } from 'reselect';
import { createFeatureSelector } from 'features/create-feature-selector';

const productsCompareRootSelector = createFeatureSelector('productsCompare');

export const getCompareErrors = createSelector(
  productsCompareRootSelector,
  (state) =>
    state?.errors || {
      manage: { error: null, productId: '', groupId: '' },
      loadData: { error: null, productId: '', groupId: '' },
    },
);

export const getManageError = createSelector(getCompareErrors, (errors) => errors.manage);
